import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bdb1e5e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "alerts-badge"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.dataLoading ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($props.urgencyCount > 99 ? "99+" : $props.urgencyCount), 1)) : _createCommentVNode("", true);
}